<template>
    <div class="t-shops-row" :class="{ 't-shops-row--active': shopCheckbox }">
        <div class="w-100" @click="selectMerchant">
            <ui-checkbox-input
                class="text-primary text-sm"
                :name="`merchant-${groupId}-${groupMerchant.id}`"
                :disabled="groupMerchant.disabled"
                v-model="shopCheckbox"
                :label="setShopLabel"
            />
            <transition-group name="slide-fade">
                <div
                    :key="1"
                    class="pl-4 mt-1 text-danger text-sm"
                    v-if="error"
                >
                    {{ error }}
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: '',
            errorDelay: 3000,
            errorTimer: null
        }
    },
    props: {
        groupId: {
            type: Number,
            required: true
        },
        groupMerchant: {
            type: Object,
            required: true
        }
    },
    computed: {
        merchant() {
            return this.$store.getters.getMerchantById(this.groupMerchant.id)
        },
        groupMerchants() {
            return this.$store.getters.getSelectedPromoGroup(this.groupId)
                .merchantIds
        },
        shopCheckbox: {
            get() {
                if (this.groupMerchant.disabled === true) {
                    return false
                } else {
                    return this.groupMerchants.find(
                        el => el.id === this.groupMerchant.id
                    ).selected
                }
            },
            set(value) {
                this.$store.dispatch('selectGroupMerchant', {
                    merchantId: this.groupMerchant.id,
                    groupId: this.groupId
                })
            }
        },
        setShopLabel() {
            const data = this.merchant
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        }
    },
    methods: {
        selectMerchant() {
            if (this.groupMerchant.disabled === true) {
                clearTimeout(this.errorTimer)
                this.error =
                    'W tej grupie nie występuje promocja, którą można uruchomić w tym sklepie.'
                this.errorTimer = setTimeout(() => {
                    this.error = ''
                }, this.errorDelay)
            }
        }
    }
}
</script>
